// @ vendors
const React = require('react');
const { map } = require('lodash');
const Immutable = require('immutable');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ components
const MortgageRequestFormattedAddress = require('../mortgageRequestEstatesData/mortgageRequestFormattedAddress/mortgageRequestFormattedAddress');

// @ constants
const { ESTATES_TYPE_ABBREVIATION, ESTATE_REGISRATION_TYPE } = require('constants/mortgageRequestEstates');
const { ADDRESS, DIR, REG_DATA, REG, CRU } = ESTATE_REGISRATION_TYPE;
const { text } = require('components/mortgageRequest/mortgageRequestEstates/initialValues');

let key;

const buildAddress = (data, hasNSResult) => {
    return (
        <div className="col-xs-12" key={`${key}-0`}>
            <MortgageRequestFormattedAddress
                immEstate={Immutable.fromJS(data)}
                className="mortgage-request-simple-note-result-successful-living-place__value"
                compact={!hasNSResult}
            />
        </div>
    );
};


const buildCru = data => {
    const { idufir } = data;

    return (
        <div key={`${key}-1`} className="col-xs-12 mortgage-request-simple-note-result-successful-living-place">
            <span className="mortgage-request-simple-note-result-successful-living-place__title">
                {formatText('mortgageRequestEstatesSuccessfulResult-idufirTitle')}
            </span>
            <span className="mortgage-request-simple-note-result-successful-living-place__value">
                {idufir}
            </span>
        </div>
    );
};

const buildRegData = (data, provinceText, populationText) => {

    if (data.registerData) {
        const textValue = text();
        const textInfo = {
            [textValue.LABEL.PROVINCE]: `${provinceText}, `,
            [textValue.LABEL.POPULATION]: `${populationText}, `,
            [textValue.LABEL.REGISTER_NAME]: `${data.registerData.label}, `,
            [textValue.LABEL.ESTATE_NUMBER]: `${data.registerFincaNumber}, `,
            [textValue.LABEL.SECTION]: `${data.registerSection}, `,
            [textValue.LABEL.BOOK]: `${data.registerBook}, `,
            [textValue.LABEL.VOLUME]: `${data.registerVolume}, `,
            [textValue.LABEL.FOLIO]: `${data.registerFolio} `
        };

        const textHtml = map(textInfo, (value, param) => <span key={param}>{param}: {value} </span>);


        return (
            <div key={`${key}-2`} className="col-xs-12">
                <p className="mortgage-request-estates__info-page-paragraph">
                    {textHtml}
                </p>
            </div>
        );
    }
    return '';
};

const propertyIdentification = (data, hasNSResult, propKey = 0) => {
    key = propKey;
    const { provinceData, populationData, propertyType, idType } = data;
    const provinceText = provinceData ? `${provinceData.label}` : '';
    const populationText = populationData ? `${populationData.label}` : '';
    const html = [];

    if (propertyType === ESTATES_TYPE_ABBREVIATION.VIVIENDA) {
        html.push(buildAddress(data, hasNSResult));
    }

    switch (idType) {
        case DIR:
        case ADDRESS:
            if (propertyType !== ESTATES_TYPE_ABBREVIATION.VIVIENDA) {
                html.push(buildAddress(data, hasNSResult));
            }
            break;

        case CRU:
            html.push(buildCru(data));
            break;

        case REG:
        case REG_DATA:
            html.push(buildRegData(data, provinceText, populationText));
            break;
    }

    return (
        <div className="row">
            {html}
        </div>
    );
};

module.exports = propertyIdentification;
